import { render, staticRenderFns } from "./BeneficiaryInformation.vue?vue&type=template&id=59f02c6c"
import script from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports